<template>
  <div data-test="outside-vif">
    <div class="rounded_corner" v-if="featureEnabled">
      <div class="panel-pane">
        <h2 class="title">
          New - SciShield brings access to Health and Safety SOPs through
          eLabNext
        </h2>
        <div id="content-top" class="content">
          <div
            id="block-scisure_integration-0"
            class="clear-block block block-scisure_integration"
          >
            <div class="content">
              <ul>
                <li>
                  Centralized access to all organization's SOPs for Researchers.
                </li>
                <li>
                  Create research protocols and share them with the members in
                  your lab.
                </li>
                <li>
                  Further extend the use of research protocols and SOPs with the
                  integrated Electronic Lab Notebook and Sample Management
                  Capabilities of eLabNext.
                </li>
              </ul>
              <div id="elabnext-blocks">
                <VActionButton
                  :show-badge="false"
                  :show-icon="false"
                  label="Go to eLabNext"
                  @click="goToELabNext"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useNotification } from "@/composables/useNotification";
import { restClient } from "@/lib/raftApi";
import VActionButton from "@/components/raft/VActionButton.vue";
import { useModulesEnabled } from "@/composables/useModulesEnabled";

export default {
  name: "ELabNextButton",
  components: { VActionButton },
  setup() {
    const { modulesEnabled, getModules } = useModulesEnabled();
    const { showNotification } = useNotification();
    return {
      modulesEnabled,
      getModules,
      showNotification,
    };
  },
  data() {
    return {
      config: null,
    };
  },
  methods: {
    async getConfiguration() {
      const response = await restClient
        .get({
          path: "configuration/scisure_integration.elabnext",
          queries: {},
        })
        .catch((error) => {
          this.showNotification({
            message: "An error has occurred. Please try again later. " + error,
            type: "error",
          });
        });
      this.config = response;
    },
    async goToELabNext() {
      if (this.config?.elabnext_host) {
        window.location.href = this.config.elabnext_host;
      }
    },
  },
  computed: {
    featureEnabled() {
      return true;
      return !!this.config?.enable_elabnext_block || false;
    },
  },
  async mounted() {
    await this.getModules();
    await this.getConfiguration();
  },
};
</script>

<style scoped>
#block-scisure_integration-0 {
  margin-bottom: 0.5rem;
}
</style>
